// extracted by css-extract-rspack-plugin
export default {"ImageUpload":"ImageUpload-uGCwuL","imageUpload":"ImageUpload-uGCwuL","uploadButton":"uploadButton-MX7SwP"};